import svg from "@/assets/images/red.svg";

export default function LoadingLogo() {
  return (
    <>
      <div className="absolute w-40 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 ml-auto mr-auto block">
        <img src={svg} className="loading-icon block w-20 h-20 ml-auto mr-auto animate-spin [animation-duration:1.5s] motion-reduce:animate-none" />
      </div>
    </>
  );
}
